import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9jbcq5zd5m: FaireBrandEntity = {
  token: "b_9jbcq5zd5m",
  type: "brand",
  name: "The Beachwaver Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/e1ba47019ddea2b94ca1ad372dcb8f5bb2c49ca4276f7c8e4a72e7a41cfbf6b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f62950cd4f4f30fd3b1e2400c08352dc2b76d9244fcf62b0f13077649ea3a4de.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e1ba47019ddea2b94ca1ad372dcb8f5bb2c49ca4276f7c8e4a72e7a41cfbf6b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f62950cd4f4f30fd3b1e2400c08352dc2b76d9244fcf62b0f13077649ea3a4de.jpeg",
  location: "WAUKEGAN, IL, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "In 2010, renowned celebrity hairstylist @SarahPotempa sketched the first-ever patented rotating curling iron. Teaming up with her sisters and top engineers, they spent two years perfecting the design—launching The Beachwaver Co.® in 2012. The patented innovation took the industry by storm, evolving from a single product into a globally recognized brand of cutting-edge styling tools and high-performance vegan, science-backed haircare.\nBuilt on empowerment, ambition, strength, beauty, and love, Beachwaver is more than just hair—it’s about confidence, dreams, and making waves.\nPremium vegan, science-backed haircare and patented styling tools designed to deliver real results. Known for our innovative, versatile products powered by high-quality ingredients, we offer solutions for every hair type and texture.\n \nCommitted to sustainability, inclusivity and accessibility, we empower individuals to embrace their unique beauty and unlock their full potential—because we believe everyone is capable of incredible things.\n\nBeachwaver is an independent, women-owned brand that’s making waves in the beauty industry.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:06.314Z",
    importedBy: "entity-db-cli",
  },
};
